﻿//GENERAL
export const SHOW_MODAL = "SHOW_MODAL";
export const SET_TEXTS = "SET_TEXTS";
export const SET_CONSTANTS = "SET_CONSTANTS";
export const SET_PAGE_LOADER_TEXTS = "SET_PAGE_LOADER_TEXTS";
export const SET_BUTTON_TEXTS = "SET_BUTTON_TEXTS";
export const SET_CUSTOMER_EMAIL_WARNING = "SET_CUSTOMER_EMAIL_WARNING";
export const HIDE_MODAL = "HIDE_MODAL";
export const DEACTIVATE_MODAL = "DEACTIVATE_MODAL";
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";

//ORDERS
export const GET_ORDER = "GET_ORDER";
export const STORE_ORDER = "STORE_ORDER";
export const STORE_ORDER_UPDATES = "STORE_ORDER_UPDATES";
export const SET_SELECTED_CREDIT_INSTALLMENTS = "SET_SELECTED_CREDIT_INSTALLMENTS";
export const SET_SELECTED_CREDIT_INSTALLMENTS_BY_ORDER = "SET_SELECTED_CREDIT_INSTALLMENTS_BY_ORDER";
export const CHANGE_PAYMENT_BY = "CHANGE_PAYMENT_BY";
export const CHANGE_PAYMENT_BY_ORDER = "CHANGE_PAYMENT_BY_ORDER";
export const ORDER_SUBMITTED = "ORDER_SUBMITTED";
export const ORDER_SUBMITTED_REMOTE_CHANNEL = "ORDER_SUBMITTED_REMOTE_CHANNEL";
export const STORE_PRICE_PLAN_NAME = "STORE_PRICE_PLAN_NAME";
export const STORE_DIRECTORY_LISTING_TEXT = "STORE_DIRECTORY_LISTING_TEXT";
export const STORE_CONSENT_TITLES = "STORE_CONSENT_TITLES";
export const STORE_ADDITIONAL_PRODUCT_NAME = "STORE_ADDITIONAL_PRODUCT_NAME";
export const STORE_INCLUDED_ADDITIONAL_PRODUCT_NAME = "STORE_INCLUDED_ADDITIONAL_PRODUCT_NAME";
export const STORE_LOST_ADDITIONAL_PRODUCT_NAME = "STORE_LOST_ADDITIONAL_PRODUCT_NAME";

//DISCOUNTS     
export const STORE_DISCOUNT_DETAILS = "STORE_DISCOUNT_DETAILS";
export const SET_DISCOUNT = "SET_DISCOUNT";
export const SET_DISCOUNT_BY_ORDER = "SET_DISCOUNT_BY_ORDER";
export const IS_CREDIT_CHECK_VALID = "IS_CREDIT_CHECK_VALID";
//PREAUTH
export const GET_PREAUTH = "GET_PREAUTH";
export const STORE_PREAUTH = "STORE_PREAUTH";

//NEW JOICE CREDIT CHECK getJoicecreditcheck
export const GET_JOICE_CREDITCHECK = "GET_JOICE_CREDITCHECK";
export const STORE_JOICE_CREDITCHECK = "STORE_JOICE_CREDITCHECK";

//DOWN_PAYMENT_PLAN     
export const STORE_DOWN_PAYMENT_PLAN = "STORE_DOWN_PAYMENT_PLAN";
export const CHANGE_UPFRONT_PAYMENT = "CHANGE_UPFRONT_PAYMENT";
export const CHANGE_UPFRONT_PAYMENT_BY_ORDER = "CHANGE_UPFRONT_PAYMENT_BY_ORDER";

//HARDWARE_PAYMENT
export const STORE_HARDWARE_PAYMENT = "STORE_HARDWARE_PAYMENT";
export const GET_UPDATE_HARDWARE_PAYMENT = "GET_UPDATE_HARDWARE_PAYMENT";
export const STORE_UPDATE_HARDWARE_PAYMENT = "STORE_UPDATE_HARDWARE_PAYMENT";
export const DELETE_HARDWARE_PAYMENT = "DELETE_HARDWARE_PAYMENT";
export const HANDLE_HARDWARE_PAYMENT_ERROR = "HANDLE_HARDWARE_PAYMENT_ERROR";

//CREDIT_AGREEMENT
export const CHANGE_CREDIT_AGREEMENT_SELECTED = "CHANGE_CREDIT_AGREEMENT_SELECTED";
export const RESET_CREDIT_AGREEMENT_ITEM = "RESET_CREDIT_AGREEMENT_ITEM";
export const RESET_CREDIT_AGREEMENT_ITEM_BY_ORDER = "RESET_CREDIT_AGREEMENT_ITEM_BY_ORDER";
export const RESET_CREDIT_AGREEMENT_OVERVIEW = "RESET_CREDIT_AGREEMENT_OVERVIEW";
export const UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS = "UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS";
export const UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS_BY_ORDER = "UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS_BY_ORDER";

//CREDIT_EVALUATION
export const GET_SELECTED_CREDIT_LIMIT = "GET_SELECTED_CREDIT_LIMIT";
export const STORE_SELECTED_CREDIT_LIMIT = "STORE_SELECTED_CREDIT_LIMIT";
export const GET_RESET_CREDIT_LIMIT = "GET_RESET_CREDIT_LIMIT"
export const RESET_CREDIT_LIMIT = "RESET_CREDIT_LIMIT";
export const GET_CREDIT_CHECK_RESULT = "GET_CREDIT_CHECK_RESULT";
export const STORE_CREDIT_CHECK_RESULT = "STORE_CREDIT_CHECK_RESULT";
export const SET_CREDIT_CHECK_RESULT = "SET_CREDIT_CHECK_RESULT";


//PBS
export const UPDATE_PBS_INFORMATION = "UPDATE_PBS_INFORMATION";
export const SET_PBS_ERROR = "SET_PBS_ERROR";
export const GET_CREATE_EXTERNAL_PAYMENT= "GET_CREATE_EXTERNAL_PAYMENT";
export const SET_CREATE_EXTERNAL_PAYMENT= "SET_CREATE_EXTERNAL_PAYMENT";

//TELIA_CONTRACTS
export const STORE_HAS_ANY_CONTRACT = "STORE_HAS_ANY_CONTRACT";
export const STORE_HAS_ANY_TELIA_CONTRACT = "STORE_HAS_ANY_TELIA_CONTRACT";
export const GET_TELIA_CONTRACTS = "GET_TELIA_CONTRACTS";
export const STORE_TELIA_CONTRACTS = "STORE_TELIA_CONTRACTS";
export const GET_TF_CONTRACTS = "GET_TF_CONTRACTS";
export const STORE_TF_CONTRACTS = "STORE_TF_CONTRACTS";
export const GET_SIGN_CONTRACTS = "GET_SIGN_CONTRACTS";
export const STORE_SIGN_CONTRACTS = "STORE_SIGN_CONTRACTS";
export const GET_SIGN_CONTRACTS_BY_NAME = "GET_SIGN_CONTRACTS_BY_NAME";
export const STORE_SIGN_CONTRACTS_BY_NAME = "STORE_SIGN_CONTRACTS_BY_NAME";       
export const STORE_CHECK_CONTRACTS = "STORE_CHECK_CONTRACTS";
export const SKIP_CHECK_CONTRACTS = "SKIP_CHECK_CONTRACTS";
export const SHOW_CONTRACTS = "SHOW_CONTRACTS";
export const UPDATE_CONTRACT_DATA = "UPDATE_CONTRACT_DATA";
export const SHOW_MODAL_MANUAL_SIGNING = "SHOW_MODAL_MANUAL_SIGNING";
export const SHOW_MODAL_REPEAT_SIGNING = "SHOW_MODAL_REPEAT_SIGNING";
export const SHOW_MODAL_REPEAT_SIGNING_BY_NAME = "SHOW_MODAL_REPEAT_SIGNING_BY_NAME";
export const SHOW_MODAL_DIGITAL_SIGNING = "SHOW_MODAL_DIGITAL_SIGNING";
export const SET_SELECTED_SIGNER = "SET_SELECTED_SIGNER";
export const HIDE_POPUP_MESSAGE = "HIDE_POPUP_MESSAGE";

//TERMS AND CONDITIONS
export const ACCEPT_CTC = "ACCEPT_CTC";
export const ACCEPT_CTFC = "ACCEPT_CTFC";

//PAGE TYPE
export const IS_PAYMENT_PAGE = "IS_PAYMENT_PAGE";

//LEGAL OWNER EMAIL FROM CDS
export const GET_LO_EMAIL = "GET_LO_EMAIL";
export const STORE_LO_EMAIL = "STORE_LO_EMAIL";